const roomTypeLabels: Record<string, string> = {
  ensuite: "Ensuite",
  studio: "Studio",
  shared: "Shared Room",
  private: "Private Room",
  apartment: "Apartment",
  non_ensuite: "Non-Ensuite",
  twin_ensuite: "Twin Ensuite",
  twin_studio: "Twin Studio",
  one_bed: "1 Bedroom",
  two_bed: "2 Bedroom",
  three_bed: "3 Bedroom",
  four_bed: "4 Bedroom",
  five_bed: "5 Bedroom",
  five_plus_bed: "5+ Bedroom",
  shared_room: "Shared Room",
  private_room: "Private Room",
  entire_place: "Entire Place",
  twodio: "Twodio",
  threedio: "Threedio",
  dorm: "Dormitory",
  deluxe_ensuite: "Deluxe Ensuite",
  premium_ensuite: "Premium Ensuite",
  deluxe_non_ensuite: "Deluxe Non-Ensuite",
  premium_non_ensuite: "Premium Non-Ensuite",
  twin_non_ensuite: "Twin Non-Ensuite",
  lite: "Lite",
  classic: "Classic",
  premium: "Premium",
  deluxe: "Deluxe",
  accessible: "Accessible",
  classic_courtyard: "Classic Courtyard",
  classic_plus: "Classic Plus",
  premium_plus: "Premium Plus",
  ultimate_vita: "Ultimate Vita",
  lite_plus: "Lite Plus",
  twin_room: "Twin Room",
  cluster: "Cluster",
};

export const getRoomTypeLabel = (roomType: string): string => {
  return roomTypeLabels[roomType] || roomType;
};
